'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var button = require('./button.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['container', 'value', 'label'];
var baseStyle = function baseStyle(props) {
  return {
    container: _objectSpread(_objectSpread(_objectSpread({}, button["default"].baseStyle(props)), button["default"].variants.inverted(props)), {}, {
      _active: _objectSpread(_objectSpread({}, button["default"].variants.solid(props)), {}, {
        // Overwrite active style of solid variant
        _active: null
      })
    }),
    value: {
      paddingTop: 2,
      paddingLeft: 3,
      paddingRight: 3,
      fontSize: '2xl',
      fontWeight: 'semibold'
    },
    label: {
      paddingBottom: 2,
      paddingLeft: 3,
      paddingRight: 3,
      fontSize: 'sm',
      fontWeight: 'normal',
      lineHeight: 'none'
    }
  };
};
var defaultProps = {
  colorScheme: 'blue'
};
var StatisticsButton = {
  baseStyle: baseStyle,
  parts: parts,
  defaultProps: defaultProps
};
exports["default"] = StatisticsButton;